import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import {MatRippleModule} from '@angular/material/core';
import TYPES from '../../constants/types';

@Component({
  selector: 'app-button',
  imports: [MatRippleModule],
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './button.component.scss'
})
export class ButtonComponent {
  
  BUTTON_TYPES: any;

  @Input() buttonLabel: string = '';
  @Input() buttonType: string = 'regular';
  @Input() buttonDisabled: boolean = false;
  @Output() buttonClickedEvent : EventEmitter<any> = new EventEmitter();

  constructor() {
    this.BUTTON_TYPES = TYPES.UI.BUTTON;
  }

  buttonClicked(){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
    this.buttonClickedEvent.emit();
  }

}
